import { Link } from 'react-router-dom';
import React from 'react';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-inner">
            <small>
                © 2026 VoyCalc · <Link to="/?page=terms" className="text-white">Terms</Link> · <a href="mailto:hello@voycalc.com" className="text-white">Contact</a>
            </small>
            </div>
        </footer>
    );
}

export default Footer;